export const INIT_toggleItem = () => {
    window.addEventListener('click', event => {
        const trigger = event.target;
        const dataset = trigger.dataset.toggleItem;

        if (dataset) {
            const data = JSON.parse(dataset);

            if (data) {
                const wrapper = document.getElementById(data.wrapper);
                const target = document.getElementById(data.target);

                if (wrapper && target) {
                    const items = [...wrapper.querySelectorAll('[data-toggle-item-target]')];

                    if (items) {
                        items.forEach(item => {
                            if (item !== target) {
                                item.classList.remove('is-open');
                            }
                        });
                    }

                    trigger.classList.toggle('is-open');
                    target.classList.toggle('is-open');
                }
            }
        } else {
            if (!trigger.closest('[data-toggle-item-target]')) {
                const triggers = [...document.querySelectorAll('[data-toggle-item]')];
                const items = [...document.querySelectorAll('[data-toggle-item-target]')];

                if (items) {
                    items.forEach(item => {
                        trigger.classList.remove('is-open');
                        item.classList.remove('is-open');

                        if (triggers) {
                            triggers.forEach(trigger => {
                                const dataset = trigger.dataset.toggleItem;

                                if (dataset) {
                                    const data = JSON.parse(dataset);

                                    if (data) {
                                        const target = data.target;

                                        if (target === item.id) {
                                            trigger.classList.remove('is-open');
                                        }
                                    }
                                }
                            });
                        }
                    });
                }
            }
        }
    });
};
